import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  Dialog
} from 'vant';
import store from '@/store/'

Vue.use(VueRouter)

const routes = [{
  path: '/clLink',
  name: 'clLink',
  component: () => import('@/views/imagelink/index.vue'),
  meta: {
    requiresAuth: false,
    title: '嗨任性出行礼包'
  }
},{
  path: '/clLink/a',
  name: 'clLink',
  component: () => import('@/views/imagelink/index1.vue'),
  meta: {
    requiresAuth: false,
    title: '出行生活宝10G通用流量包20元版(贵州)'
  }
},{
  path: '/clLink/b',
  name: 'clLink',
  component: () => import('@/views/imagelink/index2.vue'),
  meta: {
    requiresAuth: false,
    title: '缴费生活宝10G通用流量包20元版(贵州)'
  }
},{

  path: '/login',
  name: 'login',
  component: () =>
    import('@/views/login/'),
  meta: {
    requiresAuth: false
  } // 添加额外的自定义数据
},
  {
    path: '/poster/v1',
    name: 'poster',
    component: () =>
      import('@/views/poster/v1.vue'),
    meta: {
      requiresAuth: false,
      title: '本地生活',
      pagetitle: '本地生活'
    }
  },
  {
    path: '/nm/cmcc',
    name: 'poster',
    component: () =>
      import('@/views/index/nm_cmcc.vue'),
    meta: {
      requiresAuth: false,
      title: '本地生活',
      pagetitle: '本地生活'
    }
  },
  {
    path: '/',
    name: 'layout',
    component: () =>
      import('@/views/layout/'),
    children: [{
      path: '', // 默认子路由
      name: 'index',
      component: () =>
        import('@/views/index/indexN'),
      meta: {
        requiresAuth: false,
        title: '本地生活',
        pagetitle: '本地生活'
      }
    },{
      path: '/indexN', // 默认子路由
      name: 'indexN',
      component: () =>
        import('@/views/index/indexN'),
      meta: {
        requiresAuth: false,
        title: '本地生活',
        pagetitle: '本地生活'
      }
    },

    {
      path: '/selectMode',
      name: 'selectMode',
      component: () =>
        import('@/views/index/selectMode'),
      meta: {
        requiresAuth: false,
        title: '本地生活',
        pagetitle: '本地生活'
      }
    },
      {
        path: '/index/jfb',
        name: 'jfb',
        component: () =>
          import('@/views/index/jfb'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {
        path: '/index/vip30',
        name: 'vip30',
        component: () =>
          import('@/views/index/vip51'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {
        path: '/index/vip50',
        name: 'vip50',
        component: () =>
          import('@/views/index/vip30'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {
        path: '/index/hy',
        name: 'hy',
        component: () =>
          import('@/views/index/hy'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {
        path: '/index/ms',
        name: 'ms',
        component: () =>
          import('@/views/index/meishi'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },{
        path: '/index/shop',
        name: 'shop',
        component: () =>
          import('@/views/index/shop'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },{        path: '/index/school',        name: 'school',        component: () =>          import('@/views/index/school'),        meta: {          requiresAuth: false,          title: '本地生活',          pagetitle: '本地生活'        }      },{        path: '/index/health',        name: 'health',        component: () =>          import('@/views/index/health'),        meta: {          requiresAuth: false,          title: '美年大健康',          pagetitle: '美年大健康'        }      },
      {
        path: '/index/qxjfb',
        name: 'jfbDetail',
        component: () =>
          import('@/views/index/qxjfb'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {        path: '/index/qxcx',        name: 'cxDetail',        component: () =>          import('@/views/index/qxcx'),        meta: {          requiresAuth: false,          title: '本地生活',          pagetitle: '本地生活'        }      
    },      
    {        path: '/index/health-detail',        name: 'healthDetail',        component: () =>          import('@/views/index/health-detail'),        meta: {          requiresAuth: false,          title: '美年大健康详情',          pagetitle: '美年大健康详情'        }      
  },     
   {
        path: '/index/health-login',
        name: 'healthLogin',
        component: () =>
          import('@/views/index/health-login'),
        meta: {
          requiresAuth: false,
          title: '美年大健康登录',
          pagetitle: '美年大健康登录'
        }
      },
      {
        path: '/index/payment-processing',
        name: 'paymentProcessing',
        component: () =>
          import('@/views/index/payment-processing'),
        meta: {
          requiresAuth: false,
          title: '支付处理中',
          pagetitle: '支付处理中'
        }
      },
      {
        path: '/index/msxq',
        name: 'msDetail',
        component: () =>
          import('@/views/index/msxq'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      {
        path: '/alipayList',
        name: 'alipayList',
        component: () =>
          import('@/views/index/alipayList'),
        meta: {
          requiresAuth: false,
          title: '支付宝券',
          pagetitle: '支付宝券'
        }
      },
      {
        path: '/home', // 默认子路由
        name: 'home',
        component: () =>
          import('@/views/home/'),
        meta: {
          requiresAuth: false,
          title: '本地生活',
          pagetitle: '本地生活'
        }
      },
      // {
      //   path: '/school', // 默认子路由
      //   name: 'school',
      //   component: () =>
      //     import('@/views/home/school'),
      //   meta: {
      //     requiresAuth: false,
      //     title: '本地生活',
      //     pagetitle: '本地生活'
      //   }
      // },
      {
        path: '/getuser',
        name: 'getuser',
        component: () =>
          import('@/views/getuser/'),
        meta: {
          requiresAuth: false,
          pagetitle: '沃plus本地生活会员',
          title: '沃plus本地生活会员'
        }
      },
      {
        path: '/member',
        name: 'member',
        component: () =>
          import('@/views/member/'),
        meta: {
          requiresAuth: false,
          pagetitle: '沃plus本地生活会员',
          title: '沃plus本地生活会员'
        }
      },
      {
        path: '/zgsy',
        name: 'zgsy',
        component: () =>
          import('@/views/zgsy/'),
        meta: {
          requiresAuth: false,
          pagetitle: '中国石油',
          title: '中国石油'
        }
      },
      {
        path: '/czq',
        name: 'czq',
        component: () =>
          import('@/views/czq/'),
        meta: {
          requiresAuth: false,
          pagetitle: '充值券',
          title: '充值券'
        }
      },
      {
        path: '/tieta',
        name: 'tieta',
        component: () =>
          import('@/views/tieta/'),
        meta: {
          requiresAuth: false,
          pagetitle: '铁塔',
          title: '铁塔'
        }
      },
      {
        path: '/pay',
        name: 'pay',
        component: () =>
          import('@/views/pay/'),
        meta: {
          requiresAuth: false,
          pagetitle: '微信支付',
          title: '微信支付'
        }
      },
      {
        path: '/goodslist',
        name: 'goodslist',
        component: () =>
          import('@/views/goodslist/'),
        meta: {
          requiresAuth: false,
          pagetitle: '商超搜索',
          title: '商超搜索'
        }
      },
      {
        path: '/goodslist1',
        name: 'goodslist1',
        component: () =>
          import('@/views/goodslist1/'),
        meta: {
          requiresAuth: false,
          pagetitle: '互联网权益券',
          title: '互联网权益券'
        }
      },
      {
        path: '/qa',
        name: 'qa',
        component: () =>
          import('@/views/qa/'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/vi',
        name: 'vi',
        component: () =>
          import('@/views/video/'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/quanyi',
        name: 'quanyi',
        component: () =>
          import('@/views/quanyi/'),
        meta: {
          requiresAuth: false,
          pagetitle: '免费权益',
          title: '免费权益'
        }
      },
      {
        path: '/ljjl',
        name: 'ljjl',
        component: () =>
          import('@/views/ljjl/'),
        meta: {
          requiresAuth: false,
          pagetitle: '领劵记录',
          title: '领劵记录'
        }
      },
      {
        path: '/ljjl1',
        name: 'ljjl1',
        component: () =>
          import('@/views/ljjl1/'),
        meta: {
          requiresAuth: false,
          pagetitle: '领劵记录',
          title: '领劵记录'
        }
      },
      {
        path: '/quanyiwjh',
        name: 'quanyiwjh',
        component: () =>
          import('@/views/quanyiwjh/'),
        meta: {
          requiresAuth: false,
          pagetitle: '权益激活',
          title: '权益激活'
        }
      },
      {
        path: '/quanyijh',
        name: 'quanyijh',
        component: () =>
          import('@/views/quanyiwjh/jh'),
        meta: {
          requiresAuth: false,
          pagetitle: '权益激活',
          title: '权益激活'
        }
      },
      {
        path: '/quanyijh1232',
        name: 'quanyijh1232',
        component: () =>
          import('@/views/quanyiwjh/jh1232'),
        meta: {
          requiresAuth: false,
          pagetitle: '权益激活',
          title: '权益激活'
        }
      },
      {
        path: '/search',
        name: 'name',
        component: () =>
          import('@/views/search/'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/ljsm',
        name: 'ljsm',
        component: () =>
          import('@/views/ljsm/'),
        meta: {
          requiresAuth: false,
          pagetitle: '领劵说明',
          title: '领劵说明'
        }
      },
      {
        path: '/lingqu',
        name: 'lingqu',
        component: () =>
          import('@/views/lingqu/'),
        meta: {
          requiresAuth: false
        }
      },

      {
        path: '/selectcity',
        name: 'selectcity',
        component: () =>
          import('@/views/selectcity/'),
        meta: {
          requiresAuth: false,
          pagetitle: '选择城市'
        }
      },
      {
        path: '/my',
        name: 'my',
        component: () =>
          import('@/views/my/'),
        meta: {
          requiresAuth: false
        }
      }
      ,
      {
        path: '/coupon/login',
        name: 'couponLogin',
        component: () => import('@/views/coupon/Login.vue'),
        meta: {
          requiresAuth: false,
          title: '代金券登录',
          pagetitle: '代金券登录'
        }
      },
      {
        path: '/coupon',
        name: 'couponIndex',
        component: () => import('@/views/coupon/Index.vue'),
        meta: {
          requiresAuth: true,
          loginName: 'couponLogin',
          title: '代金券首页',
          pagetitle: '代金券首页'
        }
      },
      {
        path: '/coupon/detail/:id',
        name: 'couponDetail',
        component: () => import('@/views/coupon/Detail.vue'),
        meta: {
          requiresAuth: true,
          loginName: 'couponLogin',
          title: '代金券详情',
          pagetitle: '代金券详情'
        }
      },
      {
        path: '/coupon/claimed',
        name: 'couponClaimed',
        component: () => import('@/views/coupon/Claimed.vue'),
        meta: {
          requiresAuth: true,
          loginName: 'couponLogin',
          title: '已领取列表',
          pagetitle: '已领取列表'
        }
      }
    ]
  },
  {
    path: '/scdetail',
    name: 'scdetail',
    component: () =>
      import('@/views/scdetail/'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/scdetail1',
    name: 'scdetail1',
    component: () =>
      import('@/views/scdetail1/'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/hcy',
    name: 'hcy',
    component: () =>
      import('@/views/hcy/'),
    meta: {
      requiresAuth: false,
      pagetitle: '和彩云'
    }
  },
  {
    path: '/vipTrip',
    name: 'vipTrip',
    component: () =>
      import('@/views/vipTrip/'),
    meta: {
      requiresAuth: false,
      pagetitle: '生活会员'
    }
  },
  {
    path: '/article/:articleId',
    name: 'article',
    component: () =>
      import('@/views/article/'),
    meta: {
      requiresAuth: true
    },
    // 将动态路由参数映射到组件的 props 中，无论是访问还是维护性都很方便
    props: true
  },
  {
    path: '/userprofile',
    name: 'userprofile',
    component: () =>
      import('@/views/user-profile'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/userchat',
    name: 'userchat',
    component: () =>
      import('@/views/user-chat'),
    meta: {
      requiresAuth: true
    }
  },

]

const router = new VueRouter({
  routes: routes
})


// to: 要访问的页面右路信息
// from: 来自哪个页面的路由信息
// next: 放行的标记
router.beforeEach((to, from, next) => {
  // 校验登录状态，提示用户
  if (to.meta.requiresAuth) {
    // 如果已经登录了，就跳过
    if (store.state.user) {
      return next()
    }

    const loginName = to.meta.loginName || 'login'
    // 代金券相关页面未登录时直接跳转到代金券登录页
    if (loginName === 'couponLogin') {
      return router.replace({
        name: 'couponLogin',
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }

    Dialog.confirm({
      title: '访问提示',
      message: '该功能需要登录才能进行访问，确认登录吗？',
    }).then(() => {
      // 确认执行这里
      router.replace({
        name: loginName,
        query: {
          redirect: router.currentRoute.fullPath
        }
      })
    }).catch(() => {
      // 取消执行这里
      next(false)
    });
  } else {
    // 不需要登录状态的页面，直接过去
    next()
  }
})

export default router
